import {attr, BaseModel} from "../../lib/itn-ui-kit/data";

export default class AdditionalExpenseModel extends BaseModel {
  static urlPath = 'additional_expense'

  @attr('number') case;
  @attr('string') createdAt;
  @attr('string') updatedAt;
  @attr('string') label;
  @attr('number') deductionType;
  @attr('string') amount;
}